import caleandar from './TimeTable.Caleander';
import moment from "moment-timezone";

async function createCalendar(element, jsonUri) {
    try {
        const response = await fetch(jsonUri);

        if (!response.ok) {
            console.error(`HTTP error! Status: ${response.status}`);
            return;
        }

        let data = await response.json();
        data = data.sort((a, b) => convertToMoment(a.dtstart) - convertToMoment(b.dtstart));
        const events = data.reduce((carry, event) => {
            const isFullDay = !event.dtstart.includes('T')
            const timeRange = isFullDay ? '' : (getTimeRange(event.dtstart, event.dtend) + ' ')
            const arrayOfDates = isFullDay ? getEventsFullDays(event.dtstart, event.dtend) : [event.dtstart]
            arrayOfDates.forEach(dtstart => {
                carry.push({
                    Date: convertToMoment(dtstart).startOf('day').toDate(),
                    Title: `${timeRange}${event.summary}`,
                    Link: (e) => showEventInfo(e, event),
                });
            })
            return carry
        }, []);
        caleandar(element, events);
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

function getEventsFullDays(dtstart, dtend) {
    var dateArray = [];
    var currentDate = convertToMoment(dtstart);
    var stopDate = convertToMoment(dtend);
    // it the event is a full day event, it goes till 0:00 of the next day
    stopDate = stopDate.subtract(1, 'minute');
    while (currentDate <= stopDate) {
        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
}

function convertToMoment(dt) {
    return dt ? moment(dt, dt.includes('T') ? 'YYYYMMDDTHHmmss' : 'YYYYMMDD').tz('Europe/Vienna') : null;
}

function getTimeRange(dtstart, dtend) {
    const startDate = convertToMoment(dtstart);
    const endDate = convertToMoment(dtend);

    if (!startDate || !endDate) {
        return (startDate || endDate).format('HH:mm');
    }
    return startDate.format('HH:mm') + ' - ' + endDate.format('HH:mm');
}

function showEventInfo(e, eventData) {
    e.preventDefault();
    const modalData = {
        title: eventData.summary,
        location: eventData.location,
        description: eventData.description,
    };

    openModal(modalData);
}

function openModal(eventData) {
    const modal = document.createElement('div');
    modal.classList.add('modal-calendar');

    const modalContent = document.createElement('div');
    modalContent.classList.add('modal-calendar__content')
    modalContent.innerHTML = `
        <h4 class="!mt-0">${eventData.title}</h4>
        <p>${eventData.description ?? ''}</p>
    `;

    if (eventData.location) {
        const locationLink = document.createElement('a')
        locationLink.setAttribute('class', `flex link`)
        locationLink.setAttribute('href', `https://www.google.com/maps/search/${encodeURIComponent(eventData.location)}`)
        locationLink.setAttribute('target', '_blank')
        locationLink.innerHTML = `
            <span class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="w-5 h-5">
                    <path fill-rule="evenodd" d="M9.69 18.933l.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 00.281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 103 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 002.273 1.765 11.842 11.842 0 00.976.544l.062.029.018.008.006.003zM10 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z" clip-rule="evenodd" />
                </svg>
            </span>
            ${eventData.location}
        `
        modalContent.appendChild(locationLink)
    }

    const closeModalButton = document.createElement('button');
    closeModalButton.classList.add('modal-calendar__btn');
    closeModalButton.textContent = 'Schließen';
    closeModalButton.addEventListener('click', () => {
        document.body.removeChild(modal);
    });

    modalContent.appendChild(closeModalButton);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
}

Array.from(document.querySelectorAll('.time-table .time-table__calendar')).forEach(el => {
    createCalendar(el, '/calendar.json');
});
